"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilledBookMark = function FilledBookMark() {
  return _react2.default.createElement(
    "g",
    { id: "FilledBookMark" },
    _react2.default.createElement("path", { d: "M384.665625,0 C389.732812,0 394.579688,0.991407799 399.20625,2.9742234 C406.476562,5.83829037 412.259766,10.3547037 416.555859,16.5234633 C420.851953,22.692223 423,29.5219211 423,37.0125578 L423,462.987442 C423,470.478079 420.851953,477.307777 416.555859,483.476537 C412.259766,489.645296 406.476562,494.16171 399.20625,497.025777 C395.020312,498.788279 390.173438,499.669531 384.665625,499.669531 C374.090625,499.669531 364.947656,496.144525 357.236719,489.094514 L211.5,348.975545 L65.7632812,489.094514 C57.8320312,496.364838 48.6890625,500 38.334375,500 C33.2671875,500 28.4203125,499.008592 23.79375,497.025777 C16.5234375,494.16171 10.7402344,489.645296 6.44414063,483.476537 C2.14804687,477.307777 0,470.478079 0,462.987442 L0,37.0125578 C0,29.5219211 2.14804687,22.692223 6.44414063,16.5234633 C10.7402344,10.3547037 16.5234375,5.83829037 23.79375,2.9742234 C28.4203125,0.991407799 33.2671875,0 38.334375,0 L384.665625,0 Z", id: "Shape" })
  );
};

exports.default = FilledBookMark;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/FilledBookmark.js
// module id = 2950
// module chunks = 4